function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M46.5678 8.51961C41.2932 3.16013 32.7407 3.16013 27.4661 8.51961C26.8155 9.18068 26.2504 9.89208 25.7619 10.6401C25.2734 9.89208 24.7061 9.1784 24.0577 8.51961C18.7831 3.16013 10.2306 3.16013 4.95598 8.51961C-0.318661 13.8791 -0.318661 22.5691 4.95598 27.9286L25.7597 49.0714L46.5678 27.9286C51.8425 22.5691 51.8425 13.8791 46.5678 8.51961Z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M29.8486 47.8841C29.8486 47.8841 45.3266 32.5337 48.3548 29.0945C51.3829 25.6553 52.2625 20.4604 52.2625 20.4604C52.2625 20.4604 53.2056 27.3862 48.995 31.6177C44.7844 35.8491 31.3858 49.3848 31.3858 49.3848L29.8486 47.8841Z",
  clipRule: "evenodd",
  opacity: 0.6
});

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.4f66db44.svg";
export { ForwardRef as ReactComponent };